/**
 * New purchase order — create composer (vendor, dates, line items, totals).
 *
 * @see prototype/purchases/purchase-order-new.html — V1.1 composer baseline
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { PoComposerPage } from "../../../../features/purchase-orders/index.ts";

export const Route = createFileRoute("/(workspace)/procurement/purchase-orders/new")({
  component: NewPurchaseOrderRoute,
});

function NewPurchaseOrderRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Procurement", to: "/" },
        { label: "Purchase orders", to: "/procurement/purchase-orders" },
        { label: "New" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <PoComposerPage />
    </WorkspaceShell>
  );
}
